var hashtag_default = {
  "fontElementMap": "Tet9d",
  "hashtag": "xtnX-"
};
export {
  hashtag_default as default
};
//# sourceMappingURL=hashtag-scss.js.map
